<template>
  <div class="kt-portlet mt-5 mt-md-3 mt-lg-0">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
    >
      <div class="kt-portlet__head-label pt-3 pt-md-0">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-chart-area"></i>
        </span>
        <h3 class="kt-portlet__head-title">Overview Report</h3>
      </div>
      <div class="kt-portlet__head-toolbar"></div>
    </div>
    <div class="kt-portlet__body">
      <div class="d-flex">
        <v-col cols="12" sm="6" md="3" class="p-0" v-if="false">
          <v-text-field
            v-model="searchText"
            label="Solo"
            placeholder="Search here"
            solo
            dense
            clearable
            @keydown="setSearchText"
            @click:clear="setSearchText"
            :loading="loading"
            :disabled="loading"
            prepend-inner-icon="fa-search"
            hide-details
          />
        </v-col>

        <v-divider vertical inset class="mx-7 my-0" v-if="false" />

        <div v-show="hasDealersOptions" style="width: 30%">
          <v-combobox
            v-model="dealers"
            :items="dealersOptions"
            item-text="name"
            item-value="id"
            placeholder="Filter by dealers"
            clearable
            small-chips
            dense
            solo
            multiple
            @change="debounceSetDealer"
            :loading="loading"
            :disabled="loading"
            hide-details
          />
        </div>

        <v-divider
          v-show="hasDealersOptions"
          vertical
          inset
          class="mx-7 my-0"
        />

        <div class="d-flex">
          <v-combobox
            v-model="users"
            :items="usersOptions"
            item-text="name"
            item-value="id"
            placeholder="Filter by users"
            clearable
            small-chips
            dense
            solo
            multiple
            @change="debounceSetDealer"
            :loading="loading"
            :disabled="loading"
            hide-details
          >
            <template v-slot:prepend-item>
              <v-list-item
                ripple
                @mousedown.prevent
                @click="toggleSelectAllUser"
              >
                <v-list-item-action>
                  <v-icon>
                    {{ selectAllUser ? 'fa-check-square' : 'fal fa-square' }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Select All </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>

            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index <= 1">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text text-caption">
                (+{{ users.length - 1 }} others)
              </span>
            </template>
          </v-combobox>
          <div class="ml-2">
            <v-btn
              color="primaryMain"
              class="primaryMainText--text"
              @click.stop="showUsersManager()"
            >
              <i class="fa fa-user" style="line-height: 1px" /> Users
            </v-btn>

            <users-manager-dialog
              v-model="showUsersManagerDialog"
              @selectUser="selectUser"
            />
          </div>
        </div>

        <v-divider vertical inset class="mx-7 my-0" />
        <v-btn
          color="primaryMain"
          class="primaryMainText--text"
          @click="resetOptions"
        >
          <i class="fa fa-sync" style="line-height: 1px" /> Reset
        </v-btn>
      </div>

      <v-divider class="my-5" />

      <div class="row">
        <div class="col-lg-8">
          <top-performers
            :model="statistics"
            :showChartDialog="showChartDialog"
            :getData="getData"
            ref="topPerformers"
          />
        </div>
        <div class="col-lg-4">
          <donut-chart
            :key="'myCourseProgress'"
            :model="statistics"
            :type="'myProgress'"
            :showChartDialog="showChartDialog"
            :getData="getMyProgressData"
            ref="myCourseProgress"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <certification
            :model="statistics"
            :showChartDialog="showChartDialog"
            :getData="getCertificateData"
            ref="certifications"
          />
        </div>
        <div class="col-lg-4">
          <donut-chart
            :key="'teamCourseProgress'"
            :model="statistics"
            :type="'teamProgress'"
            :showChartDialog="showChartDialog"
            :getData="getTeamProgressData"
            ref="teamCourseProgress"
          />
        </div>
      </div>
    </div>

    <charts-dialog ref="chartDialog" />

    <chart-notice-dialog ref="chartNoticeDialog" />
  </div>
</template>
<script>
import {
  isEmpty as _isEmpty,
  map as _map,
  debounce as _debounce,
} from 'lodash-es';
import DonutChart from '@/components/client-reports/widgets/DonutChart.vue';
import Certification from '@/components/client-reports/widgets/Certifications.vue';
import ChartsDialog from '@/components/client-reports/widgets/ChartsDialog.vue';
import ChartNoticeDialog from '@/components/client-reports/widgets/ChartNoticeDialog.vue';
import TopPerformers from './widgets/TopPerformers.vue';
import EventBus from '@/plugins/eventBus';
import UsersManagerDialog from '@/components/client-reports/UsersManagerDialog.vue';
import Vue from 'vue';

export default {
  name: 'OverviewReport',

  components: {
    ChartNoticeDialog,
    Certification,
    DonutChart,
    TopPerformers,
    ChartsDialog,
    UsersManagerDialog,
  },

  data() {
    return {
      statistics: {
        mostUnitVideosCompleted: [],
        mostUnitTextCompleted: [],
        mostWatchedVideoOfTheDay: [],
        mostDaysVisited: [],
        mostVideoWatched: [],
        certifications: [],
        myProgress: [],
        teamProgress: [],
      },
      showUsersManagerDialog: false,
      loading: false,
      dealers: [],
      selectAllUser: false,
    };
  },

  computed: {
    dealersOptions() {
      return this.$store.state.overviewReport.reportData.dealers;
    },

    usersOptions() {
      return this.$store.state.overviewReport.reportData.users;
    },

    exportMode() {
      return this.$store.state.overviewReport.exportLoading;
    },

    searchText: {
      get() {
        return this.$store.state.overviewReport.searchText;
      },
      set(value) {
        return this.$store.dispatch('overviewReport/setSearchText', value);
      },
    },

    users: {
      get() {
        return this.$store.state.overviewReport.usersFilter;
      },
      set(value) {
        this.$store.dispatch('overviewReport/setUsersFilter', value);
      },
    },

    hasDealersOptions() {
      return this.dealersOptions.length > 0;
    },
  },

  methods: {
    selectUser(item) {
      this.users = item;
      this.$store.dispatch('overviewReport/setUsersFilter', item);
      this.setDealer();
    },
    showUsersManager() {
      this.showUsersManagerDialog = true;
    },
    getData() {
      this.$http
        .post('/client/reports/lms/overview', {
          user: null,
          dateFrom: this.getDateRange('topPerformers', 'dateFrom'),
          dateTo: this.getDateRange('topPerformers', 'dateTo'),
          dealers: this.getDealersForFilter(),
          usersFilter: this.getUsersForFilter(),
          exportMode: this.exportMode,
          searchText: this.searchText,
        })
        .then(({ data }) => {
          if (this.exportMode) {
            return window.open(data, '_blank');
          }

          this.statistics.mostUnitVideosCompleted =
            data.mostUnitVideosCompleted;
          this.statistics.mostUnitTextCompleted = data.mostUnitTextCompleted;
          this.statistics.mostWatchedVideoOfTheDay =
            data.mostWatchedVideoOfTheDay;
          this.statistics.mostDaysVisited = data.mostDaysVisited;
          this.statistics.mostVideoWatched = data.mostVideoWatched;

          this.$nextTick(() => {
            this.$refs.topPerformers.initializePerformers();
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('overviewReport/setDateRangeLoading', false);
          this.$store.dispatch('overviewReport/setExportLoading', false);
        });
    },

    getCertificateData() {
      this.$http
        .post('/client/reports/lms/overview/certificate', {
          user: null,
          dateFrom: this.getDateRange('certifications', 'dateFrom'),
          dateTo: this.getDateRange('certifications', 'dateTo'),
          dealers: this.getDealersForFilter(),
          usersFilter: this.getUsersForFilter(),
          exportMode: this.exportMode,
          searchText: this.searchText,
        })
        .then(({ data }) => {
          if (this.exportMode) {
            return window.open(data, '_blank');
          }

          this.statistics.certifications = data;

          this.$nextTick(() => {
            this.$refs.certifications.initializeChart();
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('overviewReport/setDateRangeLoading', false);
          this.$store.dispatch('overviewReport/setExportLoading', false);
        });
    },

    getTeamProgressData(categories = null) {
      this.$http
        .post('/client/reports/lms/overview/progress', {
          type: 'team',
          user: null,
          dateFrom: this.getDateRange('teamProgress', 'dateFrom'),
          dateTo: this.getDateRange('teamProgress', 'dateTo'),
          categories: categories !== null ? categories : [],
          dealers: this.getDealersForFilter(),
          usersFilter: this.getUsersForFilter(),
          exportMode: this.exportMode,
          searchText: this.searchText,
        })
        .then(({ data }) => {
          if (this.exportMode) {
            return window.open(data, '_blank');
          }

          this.statistics.teamProgress = data;

          this.$nextTick(() => {
            this.$refs.teamCourseProgress.initializeChart("Team's Progress");
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('overviewReport/setDateRangeLoading', false);
          this.$store.dispatch('overviewReport/setExportLoading', false);
        });
    },

    getMyProgressData() {
      this.$http
        .post('/client/reports/lms/overview/progress', {
          type: 'self',
          user: null,
          dateFrom: this.getDateRange('myProgress', 'dateFrom'),
          dateTo: this.getDateRange('myProgress', 'dateTo'),
          dealers: this.getDealersForFilter(),
          usersFilter: this.getUsersForFilter(),
          exportMode: this.exportMode,
          searchText: this.searchText,
        })
        .then(({ data }) => {
          if (this.exportMode) {
            return window.open(data, '_blank');
          }

          this.statistics.myProgress = data;

          this.$nextTick(() => {
            this.$refs.myCourseProgress.initializeChart('My Progress');
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('overviewReport/setDateRangeLoading', false);
          this.$store.dispatch('overviewReport/setExportLoading', false);
        });
    },

    showChartDialog(type, data, title) {
      this.$refs.chartDialog.initDialog(type, data, title);
    },

    getDateRange(key, type) {
      const date = this.$store.state.overviewReport.componentDates[key][type];

      if (_isEmpty(date)) {
        return null;
      }

      return date;
    },

    getReportData() {
      this.$http.get('/client/reports/lms/overview').then(({ data }) => {
        this.$store.dispatch('overviewReport/setReportData', data);
      });
    },

    debounceSetDealer: _debounce(function () {
      this.setDealer();
    }, 500),

    setDealer() {
      this.$store.dispatch(
        'overviewReport/setDealers',
        _map(this.dealers, (dealer) => dealer.id)
      );
      this.loading = true;

      this.getData();
      this.getCertificateData();
      this.getTeamProgressData();
      this.getMyProgressData();
    },

    getDealersForFilter() {
      if (this.dealers.length < 1) {
        return [];
      }

      return _map(this.dealers, (dealer) => dealer.id);
    },

    setUsersForFilter: _debounce(function () {
      this.$store.dispatch(
        'overviewReport/setUsers',
        _map(this.users, (user) => user.id)
      );
      this.loading = true;
    }),

    getUsersForFilter() {
      if (this.users.length < 1) {
        return [];
      }

      return _map(this.users, (user) => user.id);
    },

    setSearchText: _debounce(function () {
      this.loading = true;
      this.getData();
      this.getCertificateData();
      this.getTeamProgressData();
      this.getMyProgressData();
    }, 500),

    showNoticeDialog(message) {
      this.$refs.chartNoticeDialog.showDialog(message);
    },

    resetOptions() {
      EventBus.$emit('reset');
    },

    resetAllFilters() {
      this.searchText = '';
      this.dealers = [];
      this.users = [];
    },

    toggleSelectAllUser() {
      this.selectAllUser = !this.selectAllUser;

      if (this.selectAllUser) {
        this.$store.dispatch(
          'overviewReport/setUsersFilter',
          this.usersOptions
        );
      } else {
        this.$store.dispatch('overviewReport/setUsersFilter', []);
      }
    },
  },

  mounted() {
    this.getReportData();
    this.getData();
    this.getCertificateData();
    this.getTeamProgressData();
    this.getMyProgressData();

    EventBus.$on('reset', () => {
      this.resetAllFilters();
    });

    Vue.prototype.$echo
      .channel('app-user-store')
      .listen('AppUserStore', (e) => {
        this.getReportData();
      });
  },
};
</script>
<style scoped lang="stylus">
.overview-table
  table-layout fixed
</style>
